import { render, staticRenderFns } from "./CardVerticalDownload.vue?vue&type=template&id=d6421e68&scoped=true"
import script from "./CardVerticalDownload.vue?vue&type=script&lang=js"
export * from "./CardVerticalDownload.vue?vue&type=script&lang=js"
import style0 from "./CardVerticalDownload.vue?vue&type=style&index=0&id=d6421e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6421e68",
  null
  
)

export default component.exports